import { createSlice } from '@reduxjs/toolkit';
import {
  createBooking,
  createChallan,
  createRazorpayOrder,
  getChallanDetails,
  getInspectionBookingDetails,
  getInspectionDocumentDetails,
  inspectionDocumentVerify,
} from '../api/inspectionBooking';

// const covertToJSON = (data) => JSON.parse(JSON.stringify(data));

export const InspectionBookingSlice = createSlice({
  name: 'booking',
  initialState: {
    loading: false,
    razorpayLoading: false,
    challanLoading: false,
    razorpayInfo: {},
    challanInfo: {},
    error: {},
    booking: {},
    bookingLoading: false,
    challanSingleViewDetails: {},
    verifyDetails: {},
    inspectionBookingSingleViewDetails: {},
    inspectionDocumentDetails: {},
  },
  reducers: {
    clearRazorPayInfo: (state) => {
      state.razorpayInfo = {};
    },
  },
  extraReducers: {
    // create booking
    [createBooking.pending]: (state) => {
      state.bookingLoading = true;
    },
    [createBooking.fulfilled]: (state, action) => {
      state.booking = action.payload;
      state.bookingLoading = false;

      state.error = {};
    },
    [createBooking.rejected]: (state, action) => {
      state.bookingLoading = false;
      state.error = action.error;
    },
    // razorpay
    [createRazorpayOrder.pending]: (state) => {
      state.razorpayLoading = true;
    },

    [createRazorpayOrder.fulfilled]: (state, action) => {
      state.razorpayLoading = false;
      state.razorpayInfo = action.payload;
      state.error = {};
    },
    [createRazorpayOrder.rejected]: (state, action) => {
      state.razorpayLoading = false;
      state.error = action.error;
    },
    // challan data
    [createChallan.pending]: (state) => {
      state.challanLoading = true;
    },

    [createChallan.fulfilled]: (state, action) => {
      state.challanLoading = false;
      state.challanInfo = action.payload;
      state.error = {};
    },
    [createChallan.rejected]: (state, action) => {
      state.challanLoading = false;
      state.error = action.error;
    },
    [getChallanDetails.pending]: (state) => {
      state.loading = true;
    },
    [getChallanDetails.fulfilled]: (state, action) => {
      state.loading = false;
      state.challanSingleViewDetails = action.payload;
      state.error = {};
    },
    [getChallanDetails.rejected]: (state, action) => {
      state.loading = false;
      state.error = action.error;
    },

    [inspectionDocumentVerify.pending]: (state) => {
      state.loading = true;
    },
    [inspectionDocumentVerify.fulfilled]: (state, action) => {
      state.loading = false;
      state.verifyDetails = action.payload;
      state.error = {};
      localStorage.setItem('verifyDetails', JSON.stringify(action.payload));
    },
    [inspectionDocumentVerify.rejected]: (state, action) => {
      state.loading = false;
      state.error = action.error;
    },
    [getInspectionBookingDetails.pending]: (state) => {
      state.loading = true;
    },
    [getInspectionBookingDetails.fulfilled]: (state, action) => {
      state.loading = false;
      state.inspectionBookingSingleViewDetails = action.payload;
      state.error = {};
    },
    [getInspectionBookingDetails.rejected]: (state, action) => {
      state.loading = false;
      state.error = action.error;
    },
    [getInspectionDocumentDetails.pending]: (state) => {
      state.loading = true;
    },
    [getInspectionDocumentDetails.fulfilled]: (state, action) => {
      state.loading = false;
      state.inspectionDocumentDetails = action.payload;
      state.error = {};
    },
    [getInspectionDocumentDetails.rejected]: (state, action) => {
      state.loading = false;
      state.error = action.error;
    },
  },
});
export const { clearRazorPayInfo } = InspectionBookingSlice.actions;

export default InspectionBookingSlice.reducer;
